<template>
    <div id="popup_wrap" :style="className" v-show="show">
      <div class="searchContainer popTit">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) in breadList" :key="index">{{item}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="back">
          <div class="tit">{{title}}</div>
          <slot name="button"></slot>
          <el-button style="margin-left: 12px;" type="success" size="small" @click="onBack">返 回</el-button>
        </div>
        <slot name="self"></slot>
      </div>
      <div class="popup_content">
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    bread: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    breadList () {
      if (this.bread) {
        return this.bread.split(',')
      } else {
        return []
      }
    },
    className () {
      if (this.$store.state.collapsed) {
        return {left: '64px'}
      }
    }
  },
  methods: {
    onBack () {
      this.$emit('onBack')
    }
  }
}
</script>

<style lang="scss">
  #popup_wrap{
    position: fixed;top: 100px;left: 200px;right: 0;bottom: 0;background-color: #f4f5f7;padding: 20px;z-index: 999;overflow-y: auto;transition: all 0.5s;
    @media screen and (max-width: 1442px) {
      top: 70px;left: 170px;
    }
    .popTit {
      margin-bottom: 20px;
      .back{
        display: flex;-ms-align-items: center;
        align-items: center;margin-top: 10px;padding-bottom: 10px;
      }
      .tit {color: #1eb9a1;font-size: 14px;flex-grow: 1;}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup.vue